import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostComparison() {
  const costs = [{
    sin: 'Una estafa de la que no te pudiste defender',
    costo: '£30 - £100 en promedio'
  }, {
    sin: 'Bus turístico en vez del Bus 11',
    costo: '£35 por persona'
  }, {
    sin: 'London Eye en vez del Sky Garden',
    costo: '£32 por persona'
  }, {
    sin: 'Restaurante trampa en Leicester Square',
    costo: '£20 extra por comida'
  }, {
    sin: 'Médico o farmacia sin saber qué pedir',
    costo: 'Tiempo + dinero + estrés'
  }, {
    sin: 'Taxi sin taxímetro desde el aeropuerto',
    costo: '£30 - £50 de más'
  }, {
    sin: 'Viaje a medias porque el idioma te limitó',
    costo: 'No tiene precio',
    highlight: true
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900 border-y border-slate-800" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-800 text-slate-300 mb-6 border border-slate-700" data-id="element-48">
            <Scale className="w-8 h-8" data-id="element-49" />
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-50">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass-panel rounded-2xl overflow-hidden mb-12" data-id="element-51">
          <table className="w-full text-left border-collapse" data-id="element-52">
            <thead data-id="element-53">
              <tr data-id="element-54">
                <th className="p-4 border-b border-slate-700 text-slate-400 font-semibold w-1/2" data-id="element-55">
                  Sin PackViajero
                </th>
                <th className="p-4 border-b border-slate-700 text-slate-400 font-semibold w-1/2" data-id="element-56">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-57">
              {costs.map((row, i) => <tr key={i} className={`border-b border-slate-800/50 ${row.highlight ? 'bg-red-950/20' : ''}`} data-id="element-58">
                  <td className={`p-4 ${row.highlight ? 'text-red-400 font-bold' : 'text-slate-300'}`} data-id="element-59">
                    {row.sin}
                  </td>
                  <td className={`p-4 ${row.highlight ? 'text-red-400 font-bold' : 'text-slate-400'}`} data-id="element-60">
                    {row.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-61">
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-62">
            El PackViajero cuesta menos que una sola estafa evitada. Cuesta
            menos que un tour en bus turístico. Cuesta menos que una entrada al
            London Eye.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-amber-400 italic" data-id="element-63">
            "El próximo viaje puede ser completamente diferente." 🇬🇧
          </p>
        </motion.div>
      </div>
    </section>;
}